var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-card"},[_c('div',{staticClass:"billing-card__content"},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"billing-card__name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }